{
  "_source": "SnapSend SEO metadata, Kam Lall, 2026-10-09. Copy is the client's - reproduce verbatim.",
  "site": {
    "name": "SnapSend",
    "origin": "https://snapsend.co.uk",
    "locale": "en_GB",
    "twitter": "@snapsendsorted",
    "defaultImage": "/assets/images/share/snapsend-default.jpg",
    "defaultImageAlt": "SnapSend: send or recycle furniture and bulky items across the UK",
    "defaultImageWidth": 1200,
    "defaultImageHeight": 630,
    "logo": "/assets/images/home-v2/snapsend-logo-full.png",
    "sameAs": [
      "https://x.com/snapsendsorted",
      "https://www.instagram.com/snapsendsorted",
      "https://www.linkedin.com/company/snapsendsorted/",
      "https://www.facebook.com/people/SnapSend/61594686321964/"
    ]
  },
  "pages": {
    "/": {
      "title": "SnapSend | Furniture Delivery & Recycling Collection UK",
      "description": "Send or recycle furniture, appliances and bulky items across the UK. Snap a photo, get an instant price and book a door-to-door collection in a few clicks.",
      "breadcrumb": "Home"
    },
    "/how-it-works": {
      "title": "How SnapSend Works | Snap, Send, Sorted in 3 Steps",
      "description": "Add photos of your item, choose delivery or recycling, and book at a clear price. We arrange collection from your door and you can track it all the way.",
      "breadcrumb": "How It Works"
    },
    "/about": {
      "title": "About SnapSend | Big-Item Delivery Using Spare Van Space",
      "description": "SnapSend moves and recycles the things that won't fit in a parcel, using space on vehicles already travelling. Fewer empty miles, collected with care.",
      "breadcrumb": "About Us"
    },
    "/coverage": {
      "title": "Check Coverage | UK Collection Areas & Dates | SnapSend",
      "description": "Enter your postcode to see the soonest collection slot in your area. SnapSend collects furniture and bulky items for delivery or recycling across the UK.",
      "breadcrumb": "Check Coverage"
    },
    "/contact-us": {
      "title": "Contact SnapSend | Questions About Quotes & Collections",
      "description": "Questions about a collection, a quote or an existing order? Send the SnapSend team a message and we'll get back to you shortly.",
      "breadcrumb": "Contact Us"
    },
    "/item-enquiry": {
      "title": "Item Enquiry | Get a Quote for an Unusual Item | SnapSend",
      "description": "Got something awkward or unusual to send? Tell us about your item in a minute and we'll work out a price by hand and come back to you.",
      "breadcrumb": "Item Enquiry"
    },
    "/faqs": {
      "title": "FAQs | Booking, Pricing, Collection & Insurance | SnapSend",
      "description": "Answers to common SnapSend questions: how to book, how prices are worked out, the areas we cover, tracking, insurance and what happens to recycled items.",
      "breadcrumb": "FAQs"
    },
    "/help": {
      "title": "Help & Support | Track Orders & Get Answers | SnapSend",
      "description": "Track an order, check whether we collect from your postcode, or find quick answers to common questions. Still stuck? The SnapSend team is here to help.",
      "breadcrumb": "Help & Support"
    },
    "/track": {
      "title": "Track Your Order | SnapSend Delivery Tracking",
      "description": "Enter your SnapSend order reference to see where your item is and when it's due, from booked and collected through to in transit and delivered.",
      "breadcrumb": "Track Order"
    },
    "/reviews": {
      "title": "SnapSend Reviews | What Our Customers Say",
      "description": "Read real feedback from customers who have sent or recycled furniture and bulky items with SnapSend, then book your own collection in a few clicks.",
      "breadcrumb": "Reviews"
    },
    "/blog": {
      "title": "SnapSend Blog | Furniture Reuse, Recycling & Delivery",
      "description": "Articles from SnapSend on furniture waste, reuse and recycling, and easier ways to move big items door to door across the UK.",
      "breadcrumb": "Blog"
    },
    "/blog/the-sofa-in-the-skip": {
      "title": "The Sofa in The Skip: UK Furniture Waste | SnapSend",
      "description": "UK households throw away about 22 million pieces of furniture a year, much of it still usable. Why moving it is the hard part, and how reuse can win.",
      "breadcrumb": "The Sofa in The Skip",
      "image": "/assets/images/blog/the-sofa-in-the-skip.jpg",
      "imageWidth": 1200,
      "imageHeight": 630,
      "imageAlt": "A discarded sofa and mattress left on a residential kerbside"
    },
    "/blog/environmentally-conscious": {
      "title": "Environmentally Conscious Furniture Disposal | SnapSend",
      "description": "You shouldn't need a hire van, a free Saturday and a trip to the tip to do the right thing with a sofa. How SnapSend makes the lower-carbon choice easy.",
      "breadcrumb": "Environmentally Conscious",
      "image": "/assets/images/blog/environmentally-conscious.jpg",
      "imageWidth": 1200,
      "imageHeight": 630,
      "imageAlt": "An abandoned fabric sofa left against a weathered brick wall"
    },
    "/blog/big-items-door-to-door": {
      "title": "Big Items, Door to Door, Across the UK | SnapSend",
      "description": "If it won't fit in the car, you should still be able to move it without hiring a van. Sofas, beds, wardrobes and more, collected and delivered door to door.",
      "breadcrumb": "Big items, Door to Door, Across the UK",
      "image": "/assets/images/blog/big-items-door-to-door.jpg",
      "imageWidth": 1200,
      "imageHeight": 630,
      "imageAlt": "A red sofa strapped to the roof of a small car"
    },
    "/terms": {
      "title": "Terms & Conditions | SnapSend",
      "description": "SnapSend's terms and conditions: bookings and quotes, pricing and payment, changes and cancellations, items we cannot carry, and liability and insurance.",
      "breadcrumb": "Terms"
    },
    "/privacy": {
      "title": "Privacy Policy | SnapSend",
      "description": "How SnapSend collects, uses, shares and stores your personal information, how payment details are handled, and the rights you have over your data.",
      "breadcrumb": "Privacy Policy"
    },
    "/cookies": {
      "title": "Cookie Policy | SnapSend",
      "description": "What SnapSend stores on your device and why, the analytics choice you can make, the third-party services we load, and how to manage storage.",
      "breadcrumb": "Cookies"
    }
  }
}
